"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaskReviewProgress = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const classnames_1 = __importDefault(require("classnames"));
const task_review_progress_styles_1 = require("./task-review-progress.styles");
const localization_1 = require("../../../../../../../localization");
const TaskReviewProgress = ({ productsReviewed, taskCount, isLoading = false, }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const displayValue = isLoading
        ? '\u2013 / \u2013'
        : taskCount
            ? `${productsReviewed} / ${taskCount}`
            : `${productsReviewed} / -`;
    const progressPercent = taskCount
        ? Math.min(100, (productsReviewed / taskCount) * 100)
        : 0;
    const isComplete = taskCount != null && productsReviewed >= taskCount;
    return (react_1.default.createElement(task_review_progress_styles_1.StyledTaskReviewProgress, null, react_1.default.createElement("div", { className: (0, classnames_1.default)('progress-dot', { complete: isComplete }) }), react_1.default.createElement(ui_components_1.Typography, { variant: "body2", className: "progress-label" }, t({ key: 'HLQA_TABLE_COLUMN_PRODUCTS_REVIEWED' })), react_1.default.createElement(ui_components_1.Typography, { variant: "body2", className: "progress-value" }, displayValue), react_1.default.createElement(material_1.LinearProgress, { className: (0, classnames_1.default)('progress-bar', { loading: isLoading, complete: isComplete }), variant: isLoading ? 'indeterminate' : 'determinate', value: isLoading ? undefined : progressPercent })));
};
exports.TaskReviewProgress = TaskReviewProgress;
